export default {"src":"/kelp/_next/static/media/kernel_dao_outlined.f37f58ef.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};